import PropTypes from 'prop-types'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import QuickCheckoutEmrOrdersProvider from '@app/context/QuickCheckoutEmrOrders'
import Box from '@mui/material/Box'
import Typography from '@app/stories/Typography'
import Button from '@mui/material/Button'
import ChatIcon from '@mui/icons-material/Chat'

const VITE_STRIPE_KEY = import.meta.env.VITE_STRIPE_KEY

const promise = loadStripe(VITE_STRIPE_KEY)

// Helper function to open Intercom chat
const openIntercomChat = () => {
  if (window.Intercom) {
    window.Intercom('show')
  }
}

const QuickCheckoutContainerOrders = ({ clientSecret, paymentIntent, children }) => {
  if (!clientSecret) {
    console.error('QuickCheckoutContainerOrders: clientSecret is required')
    return (
      <Box sx={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant='h6' color='error'>
          Missing payment configuration
        </Typography>
        <Typography variant='body1' sx={{ mt: 1, mb: 2 }}>
          We're experiencing a technical issue with the checkout process. Please contact our support
          team for assistance.
        </Typography>
        <Button
          variant='contained'
          color='primary'
          startIcon={<ChatIcon />}
          onClick={openIntercomChat}
        >
          Chat with Support
        </Button>
      </Box>
    )
  }

  if (!paymentIntent) {
    console.error('QuickCheckoutContainerOrders: paymentIntent is required')
    return (
      <Box sx={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant='h6' color='error'>
          Missing payment information
        </Typography>
        <Typography variant='body1' sx={{ mt: 1, mb: 2 }}>
          We're experiencing a technical issue with the checkout process. Please contact our support
          team for assistance.
        </Typography>
        <Button
          variant='contained'
          color='primary'
          startIcon={<ChatIcon />}
          onClick={openIntercomChat}
        >
          Chat with Support
        </Button>
      </Box>
    )
  }

  return (
    <Elements
      options={{
        clientSecret,
      }}
      stripe={promise}
    >
      <QuickCheckoutEmrOrdersProvider clientSecret={clientSecret} paymentIntent={paymentIntent}>
        {children}
      </QuickCheckoutEmrOrdersProvider>
    </Elements>
  )
}

QuickCheckoutContainerOrders.propTypes = {
  children: PropTypes.node.isRequired,
  paymentIntent: PropTypes.string.isRequired,
  clientSecret: PropTypes.string.isRequired,
}

export default QuickCheckoutContainerOrders
